import React, { useState } from 'react';
import './Home.css';
import { FaLock } from 'react-icons/fa';
import Hero from '../components/Hero';

import boxFront from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Front.jpeg';
import boxBack from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Back.jpeg';
import boxSide1 from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Side 1.jpeg';
import boxSide2 from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Side 2.jpeg';
import boxSide3 from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Side 3.jpeg';
import boxSide4 from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Side 4.jpeg';
import boxOpen from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Open.jpeg';
import boxContent from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Content.jpeg';
import africanSavanna from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - African Savanna Deck.jpeg';
import americanPlains from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - American Plains Deck.jpeg';
import boxPromos from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands Box - Promos.jpeg';
import kidsPlayingCards from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands - Kids Playing Drawing Cards.jpeg';
import kidsPlayingHunt from '../img/products/kits/golden_grasslands/BioEra Golden Grasslands - Kids Playing Dynamic Hunt.jpeg';
import bioEraIsHere from '../img/products/kits/golden_grasslands/bioera_is_here.jpg';
import collectOurEpicWorld from '../img/products/kits/golden_grasslands/collect_our_epic_world.jpg';
import hoursOfFun from '../img/products/kits/golden_grasslands/hours_of_fun.jpg';
import learnWhileYouPlay from '../img/products/kits/golden_grasslands/learn_while_you_play.jpg';

function Home() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const galleryImages = [
    {
      src: boxFront,
      alt: "Box - Front",
      description: "Kit box front view featuring grasslands artwork from North America and Africa."
    },
    {
      src: boxSide1,
      alt: "Box Side View 1",
      description: "Side panel of the box listing included components."
    },
    {
      src: boxOpen,
      alt: "Box - Opened",
      description: "Open box displaying interior components."
    },
    {
      src: boxContent,
      alt: "Box - Contents",
      description: "All components laid out: two decks, dice, promo cards, deck pouches, and rule books."
    },
    {
      src: africanSavanna,
      alt: "African Savanna Deck",
      description: "The African Savanna deck featuring iconic lifeforms like lions, elephants, and vultures."
    },
    {
      src: americanPlains,
      alt: "American Plains Deck",
      description: "The North American Plains deck featuring iconic lifeforms like bison, prairie dogs, and wolves."
    },
    {
      src: boxPromos,
      alt: "Promotional Cards",
      description: "Includes two foil promotional cards (out of 8 possible designs)."
    },
    {
      src: kidsPlayingCards,
      alt: "Kids Playing Drawing Cards",
      description: "BioEra™ shuffled deck detail."
    },
    {
      src: kidsPlayingHunt,
      alt: "Kids Playing Dynamic Hunt",
      description: "Hunting lifeforms."
    },
    {
      src: boxSide2,
      alt: "Box Side View 2",
      description: "Box side panel. BioEra™ is produced in the USA."
    },
    {
      src: boxSide3,
      alt: "Box Side View 3",
      description: "Box side panel."
    },
    {
      src: boxSide4,
      alt: "Box Side View 4",
      description: "Box side panel. Learning should be fun!"
    },
    {
      src: boxBack,
      alt: "Box - Back View",
      description: "Underside of the box."
    }
  ];

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === galleryImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };
  const featuretteItems = [
    {
      title: "BioEra™ Golden Grasslands Kit",
      description: "All you need to start playing is included in this kit: two decks, two dice, two foil promo cards, two deck pouches, and two rule books. Grab a friend and let the fun begin!",
      image: bioEraIsHere,
      alt: "BioEra Golden Grasslands - Young Minds Playing",
      hasActionButton: true,
      buttonText: "Get it now",
      buttonLink: "https://square.link/u/7OAOVPce",
      buttonClass: "btn-success",
      notice: "BioEra is only available in the South Bay Area, CA."
    },
    {
      title: "What's Inside?",
      description: "Enjoy priceless time with friends and family in this wild adventure! Build an ecosystem before anyone else to win, and strategically slow down your opponent by hunting their lifeforms.",
      image: hoursOfFun,
      alt: "BioEra Golden Grasslands - Hours of Fun",
      hasActionButton: true,
      buttonText: "Learn to play",
      buttonLink: "/play",
      buttonClass: "btn-primary"
    },
    {
      title: "Learn While You Play",
      description: "There's no better way to learn than when having fun. While playing BioEra™, you'll learn about ecosystems, food webs, phenomena, and more! The cards include fun facts, animal size comparisons, and effects inspired by our natural world.",
      image: learnWhileYouPlay,
      alt: "BioEra Golden Grasslands - Learn While You Play",
      hasActionButton: false,
      buttonText: "Get it now",
      buttonLink: "https://square.link/u/7OAOVPce",
      buttonClass: "btn-success"
    },
    {
      title: "Explore Ecosystems",
      description: "The BioEra™ Golden Grasslands kit explores two epic grassland ecosystems: the North American Plains and the African Savanna. It also includes two foil promotional cards (out of 8 possible designs).",
      image: collectOurEpicWorld,
      alt: "BioEra Golden Grasslands - Collect Our Epic World",
      hasActionButton: true,
      buttonText: "Get it now",
      buttonLink: "https://square.link/u/7OAOVPce",
      buttonClass: "btn-success"
    }
  ];

  return (
    <>
      <Hero />
      <div className="container marketing">
        {/* Hero Featurettes */}
        {featuretteItems.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <hr className="featurette-divider" />}
            <div className="row featurette">
              <div className={`col-md-7 order-2 ${index % 2 === 1 ? 'order-md-2' : 'order-md-1'}`}>
                <h2 className="featurette-heading fw-normal lh-1">
                  {item.title}
                </h2>
                <p className="lead">{item.description}</p>
                {item.hasActionButton && (
                  <p>
                    <a
                      className={`btn btn-lg ${item.buttonClass}`}
                      href={item.buttonLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.buttonText}
                    </a>
                  </p>
                )}
                {item.notice && (
                  <p className="text-center mb-4">
                    <span className="badge bg-warning text-dark me-2">Important</span>
                    {item.notice}
                  </p>
                )}
              </div>
              <div className={`col-md-5 order-1 ${index % 2 === 1 ? 'order-md-1' : 'order-md-2'}`}>
                <img
                  src={item.image}
                  className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto"
                  alt={item.alt}
                  style={{ maxWidth: '500px', width: '100%' }}
                />
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>

      {/* Product Gallery Section */}
      <div className="container marketing">
        <div className="row">
          <div className="col-12 text-center mb-4">
            <h2 className="featurette-heading fw-normal">
              BioEra™ Golden Grasslands Kit Gallery
            </h2>
            <p className="lead text-muted">
              Explore in detail.
            </p>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="gallery-container">
              {/* Image Display */}
              <div className="gallery-image-wrapper">
                <img
                  src={galleryImages[currentImageIndex].src}
                  alt={galleryImages[currentImageIndex].alt}
                  className="gallery-image img-fluid"
                />
              </div>

              {/* Navigation Controls */}
              <div className="gallery-controls">
                <button
                  className="btn btn-lg btn-outline-primary gallery-btn-prev"
                  onClick={handlePrevImage}
                  aria-label="Previous image"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                  </svg>
                </button>

                <div className="gallery-info">
                  <p className="gallery-description">
                    {galleryImages[currentImageIndex].description}
                  </p>
                  <p className="gallery-counter">
                    {currentImageIndex + 1} / {galleryImages.length}
                  </p>
                </div>

                <button
                  className="btn btn-lg btn-outline-primary gallery-btn-next"
                  onClick={handleNextImage}
                  aria-label="Next image"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </button>
              </div>

              {/* Thumbnail Indicators */}
              <div className="gallery-indicators">
                {galleryImages.map((_, index) => (
                  <button
                    key={index}
                    className={`gallery-indicator ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                    aria-label={`Go to image ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action Button */}
        <div className="row mt-4 mb-3 text-center">
          <div className="col-12">
            <a
              className="btn btn-lg btn-success"
              href="https://square.link/u/7OAOVPce"
              target="_blank"
              rel="noopener noreferrer"
            >
              Buy it now
            </a>
          </div>
          <p className=" text-center mb-4">
            <FaLock /> Safe payment with Square.
          </p>
        </div>

        <hr className="featurette-divider" />
      </div>
    </>
  );
}

export default Home;
